<template>
  <div class="analytics-container">

    <ProblemCards :problems="problems"></ProblemCards>
    <ProjectInfo :problem="problems.project"></ProjectInfo>
    <ParserInfo :problem="problems.critical"></ParserInfo>
<FreezeInfo :problem="problems.tasks"></FreezeInfo>
<UsersInfo :problem="problems.users"></UsersInfo>
<CeleryInfo :problem="problems.celery"></CeleryInfo>
<QueuesInfo :problem="problems.workers"></QueuesInfo>

<!-- Broker Queues Section -->
<!--        <div class="accordion-section">-->
<!--          <div class="accordion-header" onclick="toggleAccordion(this)">-->
<!--            <div class="accordion-title">-->
<!--              📮 Очереди сообщений-->
<!--              {% if broker_metrics.total_messages > 100 %}-->
<!--              <span class="accordion-badge critical">{{ broker_metrics.total_messages }} сообщений</span>-->
<!--              {% elif broker_metrics.total_messages > 0 %}-->
<!--              <span class="accordion-badge warning">{{ broker_metrics.total_messages }} сообщений</span>-->
<!--              {% endif %}-->
<!--            </div>-->
<!--            <div class="accordion-icon">▼</div>-->
<!--          </div>-->
<!--          <div class="accordion-content">-->
<!--            {% if broker_metrics.redis_connected %}-->
<!--            &lt;!&ndash; Queue Overview &ndash;&gt;-->
<!--            <div class="metric-group">-->
<!--              <div class="metric-item">-->
<!--                <div>📊 Всего в очередях</div>-->
<!--                <div class="metric-value {% if broker_metrics.total_messages > 100 %}style='color: #e74c3c;'{% endif %}">-->
<!--                  {{ broker_metrics.total_messages }}-->
<!--                </div>-->
<!--                <div>сообщений ожидают обработки</div>-->
<!--              </div>-->
<!--            </div>-->

<!--            &lt;!&ndash; Individual Queues &ndash;&gt;-->
<!--            <h3>📋 Детали по очередям</h3>-->
<!--            {% if broker_metrics.queue_lengths %}-->
<!--            <div class="simple-chart">-->
<!--              {% for queue, length in broker_metrics.queue_lengths.items %}-->
<!--              <div class="chart-bar">-->
<!--                <div class="chart-label">-->
<!--                  📬 {{ queue }}-->
<!--                  {% if 'high' in queue %}<span style="color: #e74c3c;">🔥</span>{% endif %}-->
<!--                  {% if 'low' in queue %}<span style="color: #3498db;">💤</span>{% endif %}-->
<!--                </div>-->
<!--                <div class="chart-line">-->
<!--                  <div class="chart-fill {% if length > 100 %}danger{% else %}info{% endif %}"-->
<!--                       style="width: {% widthratio length broker_metrics.total_messages 100 %}%;-->
<!--                                                         background: {% if length > 100 %}#e74c3c{% else %}#3498db{% endif %};">-->
<!--                    {% if length > 0 %}{{ length }}{% endif %}-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div style="min-width: 60px;">{{ length }}</div>-->
<!--              </div>-->
<!--              {% endfor %}-->
<!--            </div>-->

<!--            &lt;!&ndash; Warning for large queues &ndash;&gt;-->
<!--            {% if broker_metrics.total_messages > 100 %}-->
<!--            <div class="alert-box warning" style="margin-top: 15px;">-->
<!--              ⚠️ Критическое накопление сообщений в очереди!-->
<!--              <br>Возможные причины:-->
<!--              <ul style="margin: 10px 0 0 20px;">-->
<!--                <li>Worker'ы не справляются с нагрузкой</li>-->
<!--                <li>Ошибки в задачах приводят к повторным попыткам</li>-->
<!--                <li>Недостаточно реплик worker'ов</li>-->
<!--              </ul>-->
<!--            </div>-->
<!--            {% endif %}-->
<!--            {% else %}-->
<!--            <div class="alert-box" style="background: #d4edda; border-left-color: #27ae60;">-->
<!--              ✅ Все очереди пусты. Worker'ы справляются с нагрузкой.-->
<!--            </div>-->
<!--            {% endif %}-->

<!--            &lt;!&ndash; Redis Info &ndash;&gt;-->
<!--            <div style="margin-top: 20px; padding: 10px; background: #f8f9fa; border-radius: 8px;">-->
<!--              <small>🔗 Broker: Redis (подключено) • Всего-->
<!--                очередей: {{ broker_metrics.queue_lengths|length }}</small>-->
<!--            </div>-->
<!--            {% else %}-->
<!--            <div class="alert-box error">-->
<!--              ❌ Не удалось подключиться к брокеру сообщений (RabbitMQ)-->
<!--              <br><small>Ошибка: {{ broker_metrics.error }}</small>-->
<!--            </div>-->
<!--            {% endif %}-->
<!--          </div>-->
<!--        </div>-->


    <!--    &lt;!&ndash; Refresh Button &ndash;&gt;-->
    <!--    <a href="" class="refresh-btn" onclick="location.reload(); return false;">-->
    <!--      🔄 Обновить данные-->
    <!--    </a>-->
  </div>

</template>

<script>


import ProblemCards from "@/views/service_status/components/ProblemCards.vue";
import {AdminApi} from "@/api/admin";
import ParserInfo from "@/views/service_status/components/ParserInfo.vue";
import FreezeInfo from "@/views/service_status/components/FreezeInfo.vue";
import CeleryInfo from "@/views/service_status/components/CeleryInfo.vue";
import UsersInfo from "@/views/service_status/components/UsersInfo.vue";
import QueuesInfo from "@/views/service_status/components/QueuesInfo.vue";
import ProjectInfo from "@/views/service_status/components/ProjectInfo.vue";

export default {
  name: 'AdminDashboard',
  data() {
    return {
      problems: {
        project: {
          id: 'project-stat',
          count: 0,
          name: "ПРОЕКТЫ",
          ico: "bi-card-checklist",
          description: "Статус проектов",
          is_hide: true,
          data: []
        },
        critical: {
          id: 'parser-errors',
          count: 0,
          name: "КРИТИЧЕСКИЕ ОШИБКИ",
          ico: "bi-exclamation-triangle-fill",
          description: "Объекты парсера с ошибками",
        },
        tasks: {
          id: 'not-collected',
          count: 0,
          name: "ЗАВИСШИЕ ЗАДАЧИ",
          ico: "bi-alarm-fill",
          description: "Не собрано >2 часов",
        },
        users: {
          id: 'inactive-users',
          count: 0,
          name: "НЕАКТИВНЫЕ ПОЛЬЗОВАТЕЛИ",
          ico: "bi-person-fill",
          description: "Не входили > 30 дней",
        },
        celery: {
          id: 'celery-workers',
          count: 0,
          name: "CELERY TASKS",
          ico: "bi-heart-pulse",
          description: "Таски с ошибками",
        },
        workers: {
          id: 'worker-status',
          count: 0,
          nonzero: true,
          name: "CELERY WORKERS",
          ico: "bi-wrench-adjustable-circle",
          description: "Активных worker'ов",
        },
      }
    }
  },
  components: {ProjectInfo, QueuesInfo, UsersInfo, CeleryInfo, FreezeInfo, ParserInfo, ProblemCards},

  computed: {},
  mounted: function () {
    this.celeryStat();
    this.workerStat();
    this.objectStat();
    this.userStat();
    this.projectStat();
    document.addEventListener('DOMContentLoaded', function () {
      const savedStates = localStorage.getItem('accordionStates');
      if (savedStates) {
        const states = JSON.parse(savedStates);
        const sections = document.querySelectorAll('.accordion-section');
        sections.forEach((section, index) => {
          if (states[`accordion_${index}`]) {
            const header = section.querySelector('.accordion-header');
            const content = section.querySelector('.accordion-content');
            header.classList.add('active');
            content.classList.add('active');
          }
        });
      }

    });
  },
  methods: {
    celeryStat(){
      AdminApi.celery_stat().then(response=>{
        this.problems.celery.data = response
        this.problems.workers.data = {...this.problems.workers.data, ...response}
        this.problems.celery.count = this.problems.celery.data.unsuccessful_count
      })
    },
    workerStat(){
      AdminApi.workers_stat().then(response=>{
        this.problems.workers.data = response
        this.problems.celery.data = {...this.problems.celery.data, ...response}
        this.problems.workers.count = this.problems.workers.data.worker_status?.total || 0
      })
    },
    objectStat(){
      AdminApi.parser_object_stat().then(response=>{
        this.problems.tasks.data = response
        this.problems.critical.data = response
        this.problems.critical.count = this.problems.critical.data.error_count;
        this.problems.tasks.count = this.problems.critical.data.not_collected_count;
      })
    },
    userStat(){
      AdminApi.user_stat().then(response=>{
        this.problems.users.data = response
        this.problems.users.count = this.problems.users.data.inactive_users_count;
      })
    },
    projectStat(){
      AdminApi.project_stat().then(response=>{
        this.problems.project.data = response.stat
        this.problems.project.count = response.total;
        this.problems.project.errors = response.stat.filter(x=>x.error).length;
      })
    }
  }
}

</script>

<style scoped lang="scss">

</style>
<style>
        .analytics-container {
            padding: 20px;
        }



        .accordion-section {
            background: white;
            border-radius: 12px;
            margin-bottom: 20px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
            overflow: hidden;
        }

        .accordion-header {
            background: #f8f9fa;
            padding: 18px 24px;
            cursor: pointer;
            transition: background 0.2s;
            border-bottom: 2px solid transparent;
            display: flex;
            justify-content: space-between;
            align-items: center;
            user-select: none;
            color: #000;
        }

        .accordion-header:hover {
            background: #e9ecef;
        }

        .accordion-header.active {
            background: #ecf0f1;
            border-bottom-color: #3498db;
        }

        .accordion-title {
            font-size: 18px;
            font-weight: bold;
            display: flex;
            align-items: center;
            gap: 10px;
        }

        .accordion-badge {
            background: #565658;
            color: white;
            padding: 2px 10px;
            border-radius: 20px;
            font-size: 13px;
            margin-left: 10px;
        }

        .accordion-badge.info {
            background: #3498db;
        }

        .accordion-badge.success {
            background: #27ae60;
        }

        .accordion-badge.critical {
            background: #e74c3c;
        }

        .accordion-badge.warning {
            background: #f39c12;
        }

        .accordion-icon {
            font-size: 20px;
            transition: transform 0.3s;
        }

        .accordion-header.active .accordion-icon {
            transform: rotate(180deg);
        }

        .accordion-content {
            display: none;
            padding: 24px;
            border-top: 1px solid #ecf0f1;
            animation: fadeIn 0.3s ease;
        }

        .accordion-content.active {
            display: block;
        }

        .accordion-content h3 {
            color: #333333;
        }

        @keyframes fadeIn {
            from {
                opacity: 0;
                transform: translateY(-10px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }

        .data-table {
            width: 100%;
            border-collapse: collapse;
        }

        .data-table th,
        .data-table td {
            padding: 12px 12px;
            text-align: left;
            border-bottom: 1px solid #ecf0f1;
        }

        .data-table th {
            background: #f8f9fa;
            font-weight: 600;
            color: #2c3e50;
            font-size: 13px;
        }

        .data-table tr:hover {
            background: #e9ecef;
        }

        /* Status Badges */
        .status-badge {
            display: inline-block;
            padding: 4px 10px;
            border-radius: 20px;
            font-size: 11px;
            font-weight: bold;
        }

        .status-SUCCESS {
            background: #d4edda;
            color: #155724;
        }

        .status-FAILURE {
            background: #f8d7da;
            color: #721c24;
        }

        .status-PENDING {
            background: #fff3cd;
            color: #856404;
        }

        .status-STARTED {
            background: #d1ecf1;
            color: #0c5460;
        }

        .status-RETRY {
            background: #e2d4f1;
            color: #6f42c1;
        }

        .progress-bar {
            background: #ecf0f1;
            border-radius: 10px;
            overflow: hidden;
            height: 8px;
        }

        .progress-fill {
            background: #27ae60;
            height: 100%;
            transition: width 0.3s;
        }

        .progress-fill.danger {
            background: #e74c3c;
        }

        .queue-tag {
            display: inline-block;
            background: #ecf0f1;
            padding: 4px 10px;
            border-radius: 20px;
            font-size: 11px;
            margin: 3px;
        }

        .worker-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
            gap: 15px;
            margin-top: 15px;
            color: #333333;
        }

        .worker-card {
            background: #f8f9fa;
            border-radius: 10px;
            padding: 15px;
            border: 1px solid #e9ecef;
        }

        .alert-box {
            background: #fef3c7;
            border-left: 4px solid #f59e0b;
            color: #dc2626;
            padding: 15px;
            border-radius: 8px;
            margin-bottom: 15px;
        }

        .alert-box.error {
            background: #fee2e2;
            border-left-color: #dc2626;
        }

        .refresh-btn {
            position: fixed;
            bottom: 30px;
            right: 30px;
            background: #3498db;
            color: white;
            border: none;
            border-radius: 50px;
            padding: 12px 24px;
            cursor: pointer;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            transition: all 0.3s;
            z-index: 1000;
            font-weight: bold;
        }

        .refresh-btn:hover {
            background: #2980b9;
            transform: scale(1.05);
        }

        .metric-group {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
            gap: 15px;
            margin-top: 15px;
        }

        .metric-item {
            text-align: center;
            padding: 15px;
            background: #f8f9fa;
            border-radius: 8px;
            color: #333;
        }

        .metric-value {
            font-size: 28px;
            font-weight: bold;

        }

        .simple-chart {
            margin: 15px 0;
        }

        .chart-bar {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-bottom: 10px;
        }

        .chart-label {
            width: 150px;
            font-size: 12px;
            color: #333;
        }

        .chart-line {
            flex: 1;
            background: #ecf0f1;
            border-radius: 10px;
            overflow: hidden;
            height: 24px;
        }

        .chart-fill {
            background: #3498db;
            height: 100%;
            display: flex;
            align-items: center;
            padding-left: 8px;
            color: white;
            font-size: 11px;
        }

        .chart-fill.danger {
            background: #e74c3c;
        }

        hr {
            margin: 20px 0;
            border: none;
            border-top: 1px solid #ecf0f1;
        }
    </style>